import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";

import Layout from "../Layout";
import Badge from "../../components/Badge";
import Button from "../../components/Button";
import Modal from "../../components/Modal";
import { PlusMinusButton } from "../../components/Button";

import useModal from "../../hooks/useModal";

import './index.css';

import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
    getFirestore,
    doc,
    getDoc
} from "@firebase/firestore";

import app from "../../utils/Firebase";

const db = getFirestore(app);

export default function Menu(){
    const history = useHistory();
    const { local_id, mesa } = useParams();
    const { modalState, setModalState, handleModalClose } = useModal();
    const [ itemCounter, setItemCounter ] = useState(0);
    const [ itemSelected, setItemSelected] = useState(null);
    const [ basketItems, setBasketItems ] = useState([]);
    const [ total, setTotal] = useState(0.0);
    const [localData, setlocalData] = useState(null);
    console.log(mesa);

    useEffect( () => {
        obtenerMenu();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    } , []);

    async function obtenerMenu(){
        const localesCol = doc(db, 'locales', local_id);
        const localeSnapshot = await getDoc(localesCol);
        const localData = localeSnapshot.data();
        console.log(localData);
        localStorage.setItem("restaurant-logo", localData.logo);
        setlocalData(assingIds(localData));
        document.title = `Menu de ${localData.nombre}`;
    }

    function assingIds(local){
        for(let submenu in local.menu){
            local.menu[submenu] = local.menu[submenu].map( (item, index) => {
                return {
                    ...item,
                    id: submenu+'-'+index
                };
            });
        }

        return local;
    }
    

    const addItem = () => itemCounter < 50 ? setItemCounter(itemCounter + 1) : null;
    const deleteItem = () => itemCounter > 0 ? setItemCounter(itemCounter - 1) : null;

    const resetItemCounter = () => {
        setItemCounter(0);
    }

    const addItemsToCar = () => {
        if(itemCounter > 0){
            let new_total = itemSelected ? itemCounter * itemSelected.precio : 0.00;
            let item_exists = false;
            let new_items = basketItems.map( item => {
                if(item.id === itemSelected.id){
                    item_exists = true;
                    return {
                        ...item,
                        cantidad: item.cantidad + itemCounter
                    }
                }
                return item;
            });

            if(item_exists){
                setBasketItems(new_items);
            }

            else{
                setBasketItems([...basketItems, {...itemSelected, cantidad: itemCounter} ]);
            }

            setTotal(total + new_total);
            resetItemCounter();
            handleModalClose();
        }
    }

    const emptyBasket = () => {
        setBasketItems([]);
        setTotal(0);
    }

    const goToCheckout = () => {
        localStorage.setItem('orden', JSON.stringify(basketItems));
        localStorage.setItem('localData', JSON.stringify(localData));
        localStorage.setItem('mesa', mesa);
        window.scrollTo(0, 0);
        history.push('/checkout/'+local_id);
    }


    const orderModalContent =
            <div className='order-modal'>
                <div className='order-modal__item-image' style={
                    {
                        backgroundImage: `url(${ itemSelected ? itemSelected.url_img : ''})`,
                        backgroundSize: '100%',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center'
                    } 
                }>
                </div>
            
                <h6 style={ {marginBottom: '20px'} }>Cantidad</h6>
                <PlusMinusButton counter={ itemCounter } handleOnClickMinus= { deleteItem } handleOnClickPlus={ addItem }/>

                <div className='order-modal__footer'>
                    <div className='order-modal__total'>
                        <h6>Subtotal</h6>
                        <h3>$ {  (itemSelected ? itemCounter * itemSelected.precio : 0.00) }</h3>
                    </div>

                    <button className='button button__secondary' onClick={ addItemsToCar } style={ {padding: '15px 30px'} }>Guardar</button>
                </div>
            </div>
        
    

    const openOrderModal = (item_data) => {
        setItemSelected(item_data);
        setModalState({visible:true, content: orderModalContent });
    }

    let categories = [];
    if(localData){
        for(let category in localData.menu){
            categories.push(category);
        }
        if(categories.length > 0)
            categories = categories.sort();
    }

    return(
        <Layout local={ local_id }>
            <h2 className='restaurant__name' style={ {marginTop: '20px'} }>{ localData ? localData.nombre : '' }</h2>
            { localData ? categories.map( (category, i) => {
                return (
                    <div className='submenu' key={ i }>
                        <Badge>{ category }</Badge>
                        <div className='submenu__items'>
                            { localData.menu[category].map( (item, index) =>{
                                return(
                                    <div className='submenu__item' key={ index }>
                                        <div className='submenu__item-img' style={ 
                                            {
                                                backgroundImage: `url(${item.url_img})`,
                                                backgroundSize: 'cover',
                                                backgroundRepeat: 'no-repeat',
                                                backgroundPosition: 'center',
                                                aspectRatio: '16 / 9'
                                            }
                                        }>
                                        </div>

                                        <div className='submenu__item-details'>
                                            <h5> {item.nombre } </h5>
                                            <p> ${item.precio } </p>
                                            <p> {item.descripcion }</p>
                                            <Button handleOnClick={ () => openOrderModal(item) } color='secondary'><FontAwesomeIcon icon={ faPlus} /> Añadir</Button>
                                        </div>
                                    </div>
                                );
                            } )}
                        </div>
                    </div>
                );
            }) : null }

            <Modal title='Mi titulo' visible={ modalState.visible }  handleModalClose={ () => { resetItemCounter(); handleModalClose(); } }>
                { orderModalContent }
            </Modal>

            { basketItems.length > 0 ?
            <>
                <div className='spacer'>
                </div>
                <div className='cart'>
                    <div className='cart__content'>
                        <div className='cart__info'>
                            <div className='cart__total'>
                                <h2>Total</h2>
                                <h2><span>$</span> <span>{ total }</span></h2>
                            </div>

                            <div>
                                <button className='button button__white' onClick={ goToCheckout }>COMPRAR</button>
                            </div>
                        </div>

                        <button className='btn__empty__car' onClick={ emptyBasket }>
                            <h6>Vaciar canasta</h6>
                        </button>
                    </div>
                </div>
            </>

            : null }
        </Layout>
    );
}